<div class="content" (click)="onMouseClick($event)">
    <div class="skip-section">
        <div (click)="skipsection()" class="skip-rectangle">
            <div class="skip-text-content">
                <span class="skip-text">Skip this section for now</span>
                <span><fa-icon class="fa-2x skip-icon" [icon]='faChevronCircleRight'></fa-icon></span>
            </div>
        </div>
    </div>

    <!-- <form> -->
    <div class="row-1">
        <div class="flex-column">
            <div class="column-container">
                <div class="column-content">
                    <div class="formgroup">
                        <span><label>Customer Name</label>
                            <fa-icon [icon]='faInfoCircle' class="info" id="CustomerInfoBtn" (mouseleave)="showHideInfoToggle()" (mouseenter)="showHideInfoToggle()"></fa-icon>
                            <div id="CustomerInfo" >
                                <div class="InfoContent">
                                  Enter in the Company Name for whom you are processing the MCCLD analysis. This name also reflects your file's name within your project.
                                </div>
                                <div id="arrow" data-popper-arrow></div>
                            </div>
                        </span>
                        <input type="text" class="input-field" placeholder="For eg. XYZ Corporation" name="customername" [(ngModel)]="customerinfo.customername" (change)="detectChanges($event)" maxlength="255">
                    </div>
                    <div class="formgroup">
                        <label>Contact Person</label>
                        <input type="text" class="input-field" name="contactperson" [(ngModel)]="customerinfo.contactperson" (change)="detectChanges($event)" maxlength="100">
                    </div>
                    <div class="formgroup">
                        <span>
                            <label>Title</label>
                        </span>
                        <input type="text" name="title" [(ngModel)]="customerinfo.title" class="input-field" (change)="detectChanges($event)" maxlength="100">
                    </div>
                    <div class="formgroup">
                        <label>Contact Phone Number</label>
                        <input type="text" class="input-field" name="contactnum" [(ngModel)]="customerinfo.contactnum" (change)="detectChanges($event)" placeholder="MAX 50 Characters" maxlength="50">
                    </div>
                    <div class="formgroup">
                        <label>Email</label>
                        <input type="text" class="input-field" name="email" [(ngModel)]="customerinfo.email" (change)="detectChanges($event)" placeholder="MAX 100 Characters" maxlength="100">
                    </div>
                </div>
            </div>
            <div class="column-container">
                <div class="column-content">
                    <div class="formgroup">
                        <label>Street</label>
                          <input type="text" class="input-field" name="street" [(ngModel)]="customerinfo.street" (change)="detectChanges($event)" maxlength="255">
                    </div>
                    <div class="formgroup">
                        <label>City</label>
                        <input type="text" class="input-field" name="city" [(ngModel)]="customerinfo.city" (change)="detectChanges($event)" placeholder="MAX 50 Characters" maxlength="50">
                    </div>
                    <div class="formgroup">
                        <label>State / Province</label>
                        <input type="text" class="input-field" name="state" [(ngModel)]="customerinfo.state" (change)="detectChanges($event)" placeholder="MAX 50 Characters" maxlength="50">
                    </div>
                    <div class="formgroup">
                        <label>Country</label>
                        <input type="text" class="input-field" name="country" [(ngModel)]="customerinfo.country" (change)="detectChanges($event)" placeholder="MAX 50 Characters" maxlength="50">
                    </div>
                </div>
            </div>
        </div>
    </div>

        <div class="next-button-content">
            <button class="button-content ripple" (click)='next()'>
                <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
            </button>
        </div>
</div>

